import React from 'react'

export const SalesforceIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.65686 3.27601C7.1727 2.71442 7.89094 2.36602 8.68538 2.36602C9.74149 2.36602 10.6626 2.98121 11.1533 3.89461C11.5798 3.69564 12.0517 3.58482 12.5482 3.58482C14.4528 3.58482 15.997 5.21242 15.997 7.22006C15.997 9.228 14.4528 10.8556 12.5482 10.8556C12.3157 10.8556 12.0886 10.831 11.8687 10.7848C11.4368 11.5899 10.6135 12.1341 9.66838 12.1341C9.27293 12.1341 8.89887 12.0387 8.56549 11.8687C8.12771 12.9453 7.10709 13.7002 5.91792 13.7002C4.67935 13.7002 3.62371 12.8814 3.21862 11.7329C3.04158 11.772 2.85797 11.7926 2.66988 11.7926C1.1953 11.7926 0 10.5305 0 8.97369C0 7.93009 0.536753 7.01913 1.33492 6.53169C1.17062 6.13639 1.07939 5.70057 1.07939 5.24215C1.07939 3.45167 2.47053 2 4.18633 2C5.19379 2 6.08908 2.50041 6.65686 3.27601Z"
        fill="#129CD8"
      />
    </svg>
  )
}

export const DriftIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6001 6.73555C1.6001 2.93246 4.75077 -0.134674 8.58568 0.00456023C12.1461 0.13186 15.07 3.08761 15.07 6.65201C15.07 12.0265 8.68513 15.3482 6.58866 15.9966C6.44943 16.0404 6.33406 15.8932 6.38975 15.7778C6.40965 15.738 6.43351 15.6863 6.43351 15.6863L7.436 13.6217C7.47976 13.5222 7.42009 13.4108 7.31268 13.3949C4.07847 12.9016 1.6001 10.109 1.6001 6.73555ZM11.1118 3.1395C11.084 3.13552 11.0521 3.13154 11.0243 3.13154H7.89748C7.77018 3.13154 7.67471 3.18326 7.61901 3.28271L7.59117 3.32647L6.49321 5.25983L6.15904 5.8486C6.13915 5.88042 6.12722 5.91622 6.1312 5.956C6.14711 6.03159 6.21474 6.07933 6.30623 6.07933H6.36591H6.85521H7.02627C7.16551 6.0833 7.23711 6.19071 7.17744 6.29812C7.16949 6.31006 7.15755 6.32995 7.15755 6.32995L6.05959 8.17181C6.05959 8.17181 6.03572 8.2116 6.02777 8.23149C5.98798 8.32298 6.04766 8.41448 6.15506 8.43039C6.17893 8.43437 6.20678 8.43437 6.23065 8.43437H6.84726H6.89897C7.03025 8.45028 7.08992 8.55371 7.03025 8.67306L7.00638 8.72477L6.12324 10.5467C6.12324 10.5467 6.10335 10.5865 6.09539 10.6064C6.08744 10.6382 6.09937 10.6701 6.12722 10.686C6.15904 10.7059 6.19882 10.7059 6.23065 10.686C6.25054 10.674 6.29032 10.6382 6.29032 10.6382L9.50066 8.21557C9.50066 8.21557 9.52851 8.19568 9.54045 8.18375C9.58818 8.14795 9.60807 8.08032 9.58023 8.02462C9.5484 7.96495 9.48475 7.92915 9.41712 7.93313H8.91588C8.78858 7.92517 8.72095 7.81776 8.78062 7.72229C8.79123 7.70637 8.80184 7.694 8.81245 7.68162C8.81776 7.67543 8.82306 7.66925 8.82836 7.66262L10.2167 6.09922C10.2167 6.09922 10.2525 6.05546 10.2684 6.03557C10.3361 5.94009 10.2724 5.82473 10.1451 5.81279H10.0854H9.43701H9.37734C9.24606 5.80881 9.17844 5.68947 9.24606 5.594C9.258 5.57411 9.2938 5.5383 9.2938 5.5383L11.1755 3.39808C11.1914 3.38216 11.2033 3.36625 11.2152 3.35034C11.2709 3.2668 11.2232 3.16337 11.1118 3.1395Z"
        fill="#070707"
      />
    </svg>
  )
}
